import { render, staticRenderFns } from "./ObjectAdhoc.vue?vue&type=template&id=2d0dd037&scoped=true&"
import script from "./ObjectAdhoc.vue?vue&type=script&lang=js&"
export * from "./ObjectAdhoc.vue?vue&type=script&lang=js&"
import style0 from "./ObjectAdhoc.vue?vue&type=style&index=0&id=2d0dd037&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0dd037",
  null
  
)

export default component.exports